// extracted by mini-css-extract-plugin
export default {"screen__sized__section":"TopSection_screen__sized__section__TFGAC","video__intro":"TopSection_video__intro__GOTJi"};